import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import { createTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import * as React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import useStyles from './All.styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

interface IGreetingProps {
  loading?: boolean;
  nextSlide?: () => void;
  prevSlide?: () => void;
  lastSlide?: () => void;
  closeModal?: () => void;
}

const Greeting: React.FC<IGreetingProps> = ({
  nextSlide,
  lastSlide,
  closeModal,
}) => {
  const illustration = require('assets/Board/illustration_1.png');
  const header = require('assets/header.png');
  const classes = useStyles();

  const localCloseModal = () => {
    //TODO - API Call for adding people to the creator waitlist
    if (closeModal) {
      closeModal();
    }
  };

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box
          style={{
            position: 'absolute',
          }}
          sx={{ height: { xs: '200px', sm: '300px' }, width: '100%' }}
        >
          <img
            src={header}
            alt={'img'}
            style={{ height: '100%', width: '100%' }}
          />
        </Box>
        <Box className={classes.body}>
          <Box
            className={classes.illustrationSection}
            style={{ paddingTop: '10px' }}
            sx={{
              height: { xs: '120px', sm: '180px' },
              marginBottom: { xs: '50px', sm: '100px' },
            }}
          >
            <img src={illustration} alt={'img'} style={{ height: '100%' }} />
          </Box>
          <Box className={classes.titleTextSection}>
            <Typography className={classes.titleText}>
              Thank you! You've been added to the waitlist
            </Typography>
          </Box>
          <Box
            sx={{ paddingBottom: { xs: '0px', sm: '30px' } }}
            className={classes.buttonSection}
            onClick={() => localCloseModal && localCloseModal()}
          >
            <BigNormalButton color={'yellow'} text={'Okay'} />
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Greeting;
